/*
 * @Description:
 * @Author: 邱榕
 * @Date: 2019-04-09 14:22:32
 * @LastEditTime: 2019-09-26 10:16:59
 * @LastEditors: 邱榕
 */
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [{
  path: 'merchantSettlement',
  name: 'merchantSettlement',
  meta: {
    title: '账单管理',
    src: '/financemoduleweb/merchantSettlement'
  },
  component: () => import(/* webpackChunkName: "merchantSettlement-index" */ '../views/merchantSettlement/index.vue')
},
  /* {
           path: 'orderDetail',
           name: 'orderDetail',
           meta: {
               title: '订单详情'
           },
           component: () =>
               import ( '../views/orderDetail/index.vue')
       }, */
{
  path: 'expenseList',
  name: 'expenseList',
  meta: {
    title: '商家potal-费用单列表页面',
    src: '/financemoduleweb/expenseList'
  },
  component: () => import(/* webpackChunkName: "expenseList-index" */ '../views/expensePages/expenseList/expenseList.vue')
},
{
  path: 'payPages',
  name: 'payPages',
  meta: {
    title: '商家potal-付款单页面',
    src: '/financemoduleweb/payPages'
  },
  component: () => import(/* webpackChunkName: "payPages-index" */ '../views/expensePages/payPages/payPages.vue')
},
{
  path: 'merchantBill',
  name: 'merchantBill',
  meta: {
    title: 'POP商家开单',
    src: '/financemoduleweb/merchantBill'
  },
  component: () => import(/* webpackChunkName: "businessOrder-index" */ '../views/businessOrder/index.vue')
},
{
  path: 'merchantBillDetails',
  name: 'merchantBillDetails',
  meta: {
    title: 'POP商家开单详情',
    src: '/financemoduleweb/merchantBillDetails'
  },
  component: () => import(/* webpackChunkName: "businessOrder-details" */ '../views/businessOrder/details.vue')
},
{
  path: 'openTicket',
  name: 'openTicket',
  meta: {
    title: '待开票',
    src: '/financemoduleweb/openTicket'
  },
  component: () => import(/* webpackChunkName: "openTicket-index" */ '../views/openTicket/index.vue')
},
{
  path: 'applicationInvoice',
  name: 'applicationInvoice',
  meta: {
    title: '开票申请',
    src: '/financemoduleweb/applicationInvoice'
  },
  component: () => import(/* webpackChunkName: "applicationInvoice-index" */ '../views/applicationInvoice/index.vue')
},
{
  path: 'popPaymentDetailList',
  name: 'popPaymentDetailList',
  meta: {
    title: '结算明细查询',
    src: '/financemoduleweb/popPaymentDetailList'
  },
  component: () => import(/* webpackChunkName: "popPaymentDetailList-index" */ '../views/popPaymentDetailList/index.vue')
},
  /** 下载中心 */
  {
    path: 'downloads',
    name: 'downloads',
    meta: {
      title: '离线下载列表',
      src: '/financemoduleweb/downloads'
    },
    component: () => import(/* webpackChunkName: "downloads" */ '../views/downloads/index.vue')
  },
  // 账单付款明细查询
  {
    path: 'billPayDetail',
    name: 'billPayDetail',
    meta: {
      title: '账单付款明细查询',
      src: '/financemoduleweb/billPayDetail'
    },
    component: () => import(/* webpackChunkName: "downloads" */ '../views/billPayDetail/index.vue')
  }
]
